import { MdChecklist, MdQuiz, MdVideoLibrary } from "react-icons/md";
import { Lessons } from "./components/Lessons";
import { useSearchParams } from "react-router-dom";
import { TabItem, Tabs } from "@/components";
import { Quizzes } from "./components/Quizzes";
import { DoneQuizzes } from "./components/DoneQuizzes";

export enum ELearningTab {
  LESSON = 0,
  QUIZ = 1,
  DONE_QUIZ = 2,
}

export const KEYS_ELEARNING_SEARCH_PARAMS = {
  TAB: "tab",
  SEARCH: "s",
  STATUS: "status",
};

const TabList: TabItem[] = [
  {
    label: (
      <p className="flex items-center gap-2">
        <MdVideoLibrary className="size-5" />
        学習
      </p>
    ),
    key: ELearningTab.LESSON,
    children: <Lessons />,
  },
  {
    label: (
      <p className="flex items-center gap-2">
        <MdQuiz className="size-5" />
        テスト
      </p>
    ),
    key: ELearningTab.QUIZ,
    children: <Quizzes />,
  },
  {
    label: (
      <p className="flex items-center gap-2">
        <MdChecklist className="size-5" />
        テスト結果
      </p>
    ),
    key: ELearningTab.DONE_QUIZ,
    children: <DoneQuizzes />,
  },
];

export default function ELearning() {
  const [searchParams, setSearchParams] = useSearchParams();
  const params = Object.fromEntries([...searchParams]);
  const tab = +params[KEYS_ELEARNING_SEARCH_PARAMS.TAB] || ELearningTab.LESSON;

  const handleTabChange = (newTab: number) => {
    const updatedParams = {
      [KEYS_ELEARNING_SEARCH_PARAMS.TAB]: newTab.toString(),
    };
    setSearchParams(updatedParams, { replace: true });
  };

  return (
    <div>
      <section className="flex flex-col h-[5rem] gap-1 justify-center">
        <h1 className="text-lg font-bold leading-7 whitespace-nowrap">
          Eラーニング
        </h1>
        <p className="text-light_secondary font-normal text-xs leading-4.5">
          公正競争規約やコンプライアンス体制構築の勉強動画です。数分の動画視聴の後、簡単な習熟度確認テストを受けることができます。
        </p>
      </section>

      <Tabs tabs={TabList} keyActive={tab} onTabChange={handleTabChange} />
    </div>
  );
}
